import { all } from 'redux-saga/effects';

import workflowSaga from './workflowSaga';
import plaidSaga from './plaidSaga';
import lookupSaga from './lookupSaga';
import bankStatementsSaga from './bankStatementsSaga';

const Sagas = function* () {
  yield all([
    workflowSaga(),
    plaidSaga(),
    lookupSaga(),
    bankStatementsSaga(),
  ]);
};

export default Sagas;
